import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * News Routes and Pages
 */
const ListNewsPage = React.lazy(() => import("./ListNewsPage"));
const AddNewsPage = React.lazy(() => import("./AddNewsPage.js"));
const EditNewsPage = React.lazy(() => import("./EditNewsPage"));

const NewsRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListNewsPage />} />
      <Route exact path="/add" element={<AddNewsPage />} />
      <Route exact path="/edit/:id" element={<EditNewsPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default NewsRoutes;
